module.exports = __webpack_public_path__ + "img/credit.488db0de.png";